import React from "react"
import PropTypes from "prop-types"
import { Document, Page } from "react-pdf"
import { Loader } from "@bw/bits"
import { ArrowRight, ArrowLeft } from "@bw/icons"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import useWindowWidth from "../../../hooks/useWindowWidth"
import { pdfjs } from "react-pdf"
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs"
const Wrapper = styled.div`
  margin: 80px auto;
  overflow: auto;
`

const PageNavigation = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 60px;
  grid-gap: 5px;
  background-color: #fff;
  border-radius: 7px;
  box-shadow: 0px 15px 25px rgba(133, 172, 230, 0.25);
  width: 250px;
  height: 62px;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 0;
    background: none;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 0.3s;

    &[disabled] {
      opacity: 0;
      pointer-events: none;
    }
  }
`

const PageNumber = styled.div`
  justify-self: center;
  align-self: center;
`

const ClickToZoom = styled.div`
  margin-top: 5px;
  text-align: center;
`

const PdfViewer = ({ url }) => {
  const { t } = useTranslation()
  const windowWidth = useWindowWidth()
  const [mobileScale, setMobileScale] = React.useState(false)
  const [totalPages, setTotalPages] = React.useState(null)
  const [pageNumber, setPageNumber] = React.useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setTotalPages(numPages)
  }

  function getSize() {
    if (mobileScale) {
      return windowWidth < 768 ? 0.3 : 0.6
    }
    return windowWidth < 1590 ? 1 : 1.4
  }

  React.useEffect(() => {
    setMobileScale(windowWidth < 1150)
  }, [windowWidth])

  return (
    <Wrapper>
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onClick={() => {
          if (windowWidth < 1150) {
            setMobileScale(value => !value)
          }
        }}
        loading={
          <Loader
            messages={[t("loading"), t("loadingTakesLonger")]}
            treshold={10}
          />
        }
      >
        <Page
          {...{
            pageNumber,
            renderTextLayer: false,
            scale: getSize(),
          }}
        />
      </Document>
      {windowWidth < 1150 && mobileScale && (
        <ClickToZoom
          role="button"
          onClick={() => {
            if (windowWidth < 1150) {
              setMobileScale(value => !value)
            }
          }}
        >
          {t("magazine.clickToZoom")}
        </ClickToZoom>
      )}
      {totalPages && (
        <PageNavigation>
          <button
            disabled={pageNumber === 1}
            onClick={() => {
              setPageNumber(value => Math.max(value - 1, 1))
            }}
          >
            <ArrowLeft />
          </button>
          <PageNumber>
            {pageNumber} sur {totalPages}
          </PageNumber>
          <button
            disabled={pageNumber === totalPages}
            onClick={() => {
              setPageNumber(value => Math.min(value + 1, totalPages))
            }}
          >
            <ArrowRight />
          </button>
        </PageNavigation>
      )}
    </Wrapper>
  )
}

PdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
}

export default PdfViewer
